import { c as _c } from "react/compiler-runtime";
import { Avatar, Badge, Box, HStack, Link, Text, VStack, Wrap } from '@chakra-ui/react';
import { SessionReviewStars } from '@src/components/sco/Advisors/reviews/SessionReviewStars';
import { sessionReviewAuthorHref, sessionReviewAuthorName, type SessionReviewItem } from '@src/components/sco/Advisors/reviews/sessionReviewHelpers';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import moment from 'moment';
import { ReactNode } from 'react';
export type SessionReviewCardProps = {
  review: SessionReviewItem;
  /**
   * Manage view (reviewee): show "Hidden" / "Hidden by Startups" / "Text hidden" markers and the
   * hidden text itself (dimmed). Public views leave this off — the backend already strips them.
   */
  showManageState?: boolean;
  /** Row actions (manage view). */
  actions?: ReactNode;
};

/** One review: author, stars, date, featured badge, text when present. */
export const SessionReviewCard = t0 => {
  const $ = _c(59);
  const {
    review,
    showManageState: t1,
    actions
  } = t0;
  const showManageState = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== review) {
    t2 = sessionReviewAuthorName(review);
    $[0] = review;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const name = t2;
  let t3;
  if ($[2] !== review.author) {
    t3 = sessionReviewAuthorHref(review.author);
    $[2] = review.author;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const href = t3;
  review.author?.tagline?.trim() || null;
  let t4;
  if ($[4] !== review.createdAt) {
    t4 = review.createdAt ? moment(review.createdAt).format("MMM D, YYYY") : null;
    $[4] = review.createdAt;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const date = t4;
  const hidden = showManageState && (review.isHidden || review.isHiddenByAdmin);
  let t5;
  if ($[6] !== review.text) {
    t5 = review.text?.trim() || null;
    $[6] = review.text;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const text = t5;
  const t6 = `Review by ${name}`;
  const t7 = hidden ? "border.emphasized" : "colorPalette.border/50";
  const t8 = hidden ? "dashed" : "solid";
  const t9 = hidden ? "true" : undefined;
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      base: 3,
      md: 4
    };
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== review.author) {
    t11 = review.author?.imageUrl ? <Avatar.Image alt="" src={review.author.imageUrl} /> : null;
    $[9] = review.author;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== name) {
    t12 = <Avatar.Fallback name={name} />;
    $[11] = name;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t12) {
    t13 = <Avatar.Root flexShrink={0} size="sm">{t11}{t12}</Avatar.Root>;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== href || $[17] !== name) {
    t14 = href ? <Link asChild={true} color="inherit" fontSize="sm" fontWeight="semibold"><NextLink href={href}>{name}</NextLink></Link> : <Text fontSize="sm" fontWeight="semibold">{name}</Text>;
    $[16] = href;
    $[17] = name;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Text fontSize="sm" fontWeight="normal" opacity={0.5}>rated</Text>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== review.score) {
    t16 = <SessionReviewStars score={review.score} />;
    $[20] = review.score;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t14 || $[23] !== t16) {
    t17 = <HStack align="center" flexWrap="wrap" gap={2} minWidth={0}>{t14}{t15}{t16}</HStack>;
    $[22] = t14;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== review.isFeatured || $[26] !== review.isHidden || $[27] !== review.isHiddenByAdmin || $[28] !== review.isTextHidden || $[29] !== showManageState) {
    t18 = (review.isFeatured || showManageState && (review.isHidden || review.isHiddenByAdmin || review.isTextHidden)) && <Wrap gap={2}>{review.isFeatured && <Badge colorPalette="orange" size="sm" variant="subtle">Featured</Badge>}{showManageState && review.isHidden && <Badge colorPalette="gray" size="sm" variant="outline">Hidden from profile</Badge>}{showManageState && review.isHiddenByAdmin && <Badge colorPalette="red" size="sm" variant="outline">Hidden by Startups</Badge>}{showManageState && review.isTextHidden && <Badge colorPalette="gray" size="sm" variant="outline">Text hidden</Badge>}</Wrap>;
    $[25] = review.isFeatured;
    $[26] = review.isHidden;
    $[27] = review.isHiddenByAdmin;
    $[28] = review.isTextHidden;
    $[29] = showManageState;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17 || $[32] !== t18) {
    t19 = <VStack align="flex-start" gap={1} minWidth={0}>{t17}{t18}</VStack>;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t13 || $[35] !== t19) {
    t20 = <HStack align="center" flex={1} gap={3} minWidth={0}>{t13}{t19}</HStack>;
    $[34] = t13;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== date) {
    t21 = date && <Text color="fg.muted" flexShrink={0} fontSize="xs" whiteSpace="nowrap">{date}</Text>;
    $[37] = date;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t20 || $[40] !== t21) {
    t22 = <HStack align="flex-start" gap={3} justify="space-between">{t20}{t21}</HStack>;
    $[39] = t20;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== hidden || $[43] !== review.isTextHidden || $[44] !== showManageState || $[45] !== text) {
    t23 = text && <Text color={showManageState && review.isTextHidden ? "fg.muted" : "fg"} fontSize="sm" fontStyle={showManageState && review.isTextHidden ? "italic" : undefined} opacity={hidden ? 0.8 : 1} whiteSpace="pre-line" wordBreak="break-word">{text}</Text>;
    $[42] = hidden;
    $[43] = review.isTextHidden;
    $[44] = showManageState;
    $[45] = text;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== actions) {
    t24 = actions && <Box borderColor="colorPalette.border/50" borderTopWidth="1px" paddingTop={3}>{actions}</Box>;
    $[47] = actions;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t22 || $[50] !== t23 || $[51] !== t24) {
    t25 = <VStack align="stretch" gap={3}>{t22}{t23}{t24}</VStack>;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t25 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8 || $[57] !== t9) {
    t26 = <Box aria-label={t6} as="article" bgColor="colorPalette.container" borderColor={t7} borderRadius="xl" borderStyle={t8} borderWidth="1px" data-hidden={t9} padding={t10} width="full">{t25}</Box>;
    $[53] = t25;
    $[54] = t6;
    $[55] = t7;
    $[56] = t8;
    $[57] = t9;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  return t26;
};